import React, { useEffect, useRef, useState } from 'react';
import { InputField, PhoneNumberField, RadioButton, SelectField } from 'views/components/form-inputs';
import { Button } from 'primereact/button';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Message } from 'primereact/message';
import { userService } from 'services/user.service';
import { showTostify } from 'utils/interfaces';
import statesData from 'static.json'
import CustomToast from 'views/components/form-inputs/alert';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { routes } from 'utils/routes';
import { SEOHeader } from 'views/components';
import axios from 'axios';
import store from 'store'

const AddEditCustomer = () => {
  const toastRef = useRef<any>(null);
  const navigation = useNavigate()
  const params = useParams()
  const id: any = params.id

  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');

  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState<any>('');
  const [previewUrl, setPreviewUrl] = useState<any>('');
  const [previewUrl1, setPreviewUrl1] = useState('');
  const [avatar, setAvatar] = useState<any>([]);
  const [cities, setCities] = useState([]);

  const formik: any = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      phone_number1: "",
      phone_number2: "",
      status: "active",
      onboarding: "offline",
      role: "customer",
      username: "",
      gender: "male",
      email: "",
      password: "",
      // job_type: "full_time",
      address1: "",
      address2: "",
      landmark: "",
      postcode: "",
      country: "India",
      state: "",
      city: "",
      company_idnumber: "",
      company_name: "",
      referral_code: "",
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required('First name is required'),
      last_name: Yup.string().required('Last name is required'),
      email: Yup.string().email('Invalid email format').required('Email is required'),
      password: id ? Yup.string() : Yup.string().required('Password is required'),
      username: id ? Yup.string() : Yup.string().required('Username is required'),
      phone_number1: Yup.string().required('Phone number 1 is required'),
      // job_type: Yup.string().required('Job type is required'),
      status: Yup.string().required('Status is required'),
      city: Yup.string().required('City is required'),
      state: Yup.string().required('State is required'),
      // address1: Yup.string().required('Address is required'),
      // postcode: Yup.string().required('Postcode is required'),
      gender: Yup.string().required('Gender is required'),
    }),
    onSubmit: async (values: any) => {
      setLoading(true);
      try {
        if (id) {
          delete values?.username
          delete values?.password

          values.job_type = values?.job_type || null
          delete values?.referral_code
          const data = await userService.updateUsers(id, values);
          if (data.error === false) {
            showTostify(toastRef, 'success', data.message);
            if (selectedFile) {
              submitFile(id)
            }
            setTimeout(() => {
              navigation(`${routes.customers}?type=${type}`);
            }, 800)
          }
          else {
            showTostify(toastRef, 'error', data.message);
          }
        }
        else {
          const data = await userService.createUsers(values);
          if (data.error === false) {
            if (selectedFile) {
              submitFile(data.data.id)
            }
            showTostify(toastRef, 'success', data.message);
            formik.resetForm();
            setTimeout(() => {
              navigation(`${routes.customers}?type=${type}`);
            }, 800)
          }
          else {
            showTostify(toastRef, 'error', data.message);
          }
        }
      } catch (err: any) {
        showTostify(toastRef, 'error', err.message);
      } finally {
        setLoading(false);
      }
    }
  });

  useEffect(() => {
    if (id) {
      const fetchEmployeeDetails = async () => {
        const data = await userService.getUserDetails(id);
        if (Array.isArray(data?.media) && data?.media.length > 0) {
          setAvatar(data.media);
        } else {
          console.error('Media array is empty or not an array');
        }
        if (!data.error) {
          formik.setValues({
            first_name: data.first_name || "",
            last_name: data.last_name || "",
            email: data.email || "",
            phone_number1: data.phone_number1 || "",
            phone_number2: data.phone_number2 || "",
            status: data.status || "",
            onboarding: data.onboarding || "offline",
            role: data.role || "customer",
            username: data.username || "",
            gender: data.gender || "",
            password: data.password || "",
            job_type: data.job_type || "",
            address1: data.address1 || "",
            address2: data.address2 || "",
            landmark: data.landmark || "",
            postcode: data.postcode || "",
            country: data.country || "",
            state: data.state || "",
            city: data.city || "",
            company_idnumber: data.company_idnumber || "",
            company_name: data.company_name || "",
            referral_code: data.referral_code || "",
          });

          const selectedState: any = statesData.states.find(state => state.label === data.state);
          if (selectedState) {
            setCities(selectedState.cities);
          } else {
            setCities([]);
          }
        } else {
          showTostify(toastRef, 'error', data.message);
        }
      };
      fetchEmployeeDetails();
    }
  }, [id]);

  // const deleteEmployee = () => {
  //   userService.deleteUsers(id).then((data: any) => {
  //     if (!data?.error) {
  //       showTostify(toastRef, 'success', data.message);
  //       setTimeout(() => {
  //         navigation(`${routes.customers}?type=${type}`);
  //       }, 800)
  //     } else {
  //       showTostify(toastRef, 'error', data.message);
  //     }
  //   })
  // }
  console.log(formik.errors);

  const submitFile = async (id: any) => {
    if (selectedFile) {
      const data = new FormData();
      data.append('key', 'profile_picture');
      data.append('entity_id', `${id}`);
      data.append('files', selectedFile);
      data.append('entity_type', `user`);

      try {
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}v1/admin/media`, data, {
          headers: { 'Content-Type': 'multipart/form-data', 'Authorization': store.get(process.env.REACT_APP_ACCESS_TOKEN_KEY || 'bIESIcg42Wb9') }
        });
        showTostify(toastRef, 'success', response?.data?.message);
        setPreviewUrl('')
      } catch (error) {
        console.error('Error uploading image:', error);
        alert(error);
      }
    }
  }

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target && e.target.files) {
      const file = e.target.files[0] || null;
      if (file) {
        setSelectedFile(file);
        setPreviewUrl1(URL.createObjectURL(file));
      }
    } else {
      console.error('No files were selected.');
    }
  };

  const handleStateChange = (e: any) => {
    const selectedStateId = e.value;
    formik.setFieldValue('state', selectedStateId);
    const selectedState: any = statesData.states.find(state => state.label === selectedStateId);
    if (selectedState) {
      setCities(selectedState.cities);
      formik.setFieldValue('city', '');
    } else {
      setCities([]);
    }
  };

  return (
    <div style={{ width: "800px", margin: "auto" }}>
      <SEOHeader title="Create Customer" />
      <div className='bg-white border-round-2xl'>
        <form onSubmit={formik.handleSubmit} >
          <CustomToast ref={toastRef} />

          <div className="p-4 border-bottom-1 border-primary-color">
            <h2 className='text-start m-0'>{id ? "Edit Customer" : "Add New Customer"}</h2>
          </div>
          <div className="grid m-0 py-4 p-3">
            <div className="grid m-0">

              <div className="col-12 md:col-6 lg:col-6">
                <InputField
                  name="first_name"
                  label="First Name"

                  required={true}
                  value={formik.values.first_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik?.touched.first_name && formik.errors.first_name}
                />
              </div>

              <div className="col-12 md:col-6 lg:col-6">
                <InputField
                  name="last_name"
                  label="Last Name"

                  required={true}
                  value={formik.values.last_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik?.touched.last_name && formik.errors.last_name}
                />
              </div>

              <div className={`col-12 md:col-6 lg:col-${id ? 6 : 4}`}>
                <InputField
                  name="email"
                  label="Email"
                  required={true}
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik?.touched.email && formik.errors.email}
                />
              </div>
              <div className={`col-12 md:col-6 lg:col-${id ? 6 : 4}`}>
                <InputField
                  name="username"
                  label="Username"
                  required={true}
                  value={formik.values.username}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={id}
                  error={formik?.touched.username && formik.errors.username}
                />
              </div>
              {!id &&
                <div className="col-12 md:col-6 lg:col-4">
                  <InputField
                    name="password"
                    label="Password"
                    required={true}
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik?.touched.password && formik.errors.password}
                  />
                </div>}

              <div className="col-12 md:col-6 lg:col-6">
                <div>
                  <RadioButton
                    className="custom-form-check"
                    name="gender"
                    value={formik.values.gender || "male"}
                    onChange={(e: any) => formik.setFieldValue('gender', e.value)}
                    options={[
                      { label: 'Male', value: 'male' },
                      { label: 'Female', value: 'female' },
                      { label: 'Other', value: 'other' },
                    ]}
                    required={true}
                    label="Gender"
                    error={formik.touched.gender && formik.errors.gender}
                  />
                </div>
              </div>

              <div className="col-12 md:col-6 lg:col-6">
                <RadioButton
                  className="custom-form-check"
                  name="status"
                  value={formik.values.status || "active"}
                  onChange={(e: any) => formik.setFieldValue('status', e.value)}
                  options={[
                    { label: 'Active', value: 'active' },
                    { label: 'Inactive', value: 'suspended' },
                  ]}
                  required={true}
                  label="Status"
                  error={formik.touched.status && formik.errors.status}
                />
              </div>


              <div className="col-12 md:col-6 lg:col-6">
                <div className="form-group mb-2">
                  <label htmlFor="phone_number1">Mobile<span className='required-field'>*</span></label>
                  <PhoneNumberField
                    value={formik.values.phone_number1}
                    required={true}
                    onBlur={formik.handleBlur}
                    onChange={(phone) => formik.setFieldValue('phone_number1', phone || '')}
                  />
                  {formik.touched.phone_number1 && formik.errors.phone_number1 && (
                    <Message severity="error" text={formik.errors.phone_number1} />
                  )}
                </div>
              </div>

              <div className="col-12 md:col-6 lg:col-6">
                <div className="form-group mb-2">
                  <label htmlFor="phone_number2">Alternate Mobile</label>
                  <PhoneNumberField
                    value={formik.values.phone_number2}
                    onBlur={formik.handleBlur}
                    onChange={(phone) => formik.setFieldValue('phone_number2', phone || '')}
                  />
                </div>
              </div>

              {/* <div className="col-12 md:col-6 lg:col-4 ">
                <SelectField
                  name="job_type"
                  label="Employee Type"
                  value={formik.values.job_type || "full_time"}
                  onChange={(e) => {
                    formik.setFieldValue('job_type', e.value);
                  }}
                  options={[
                    { label: 'Full Time', value: 'full_time' },
                    { label: 'Part Time', value: 'part_time' },
                    { label: 'Student', value: 'student' },
                  ]}
                  error={formik.touched.job_type && formik.errors.job_type}
                  required={true}
                  className="my-custom-class"
                />
              </div> */}

              {formik.values.job_type === 'student' && (
                <>
                  <div className="col-12 md:col-6 lg:col-6">
                    <InputField
                      name="company_name"
                      label="Institute"

                      value={formik.values.company_name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>

                  <div className="col-12 md:col-6 lg:col-6">
                    <InputField
                      name="company_idnumber"
                      label="Role Number"

                      value={formik.values.company_idnumber}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                </>
              )}
            </div>

            <div className="col-12 md:col-6 lg:col-6">
              <SelectField
                name="state"
                showClear
                label="State"
                value={formik.values.state}
                onChange={handleStateChange}
                options={statesData?.states?.map(state => ({ label: state.label, value: state.label }))}
                error={formik.touched.state && formik.errors.state}
                required={true}
                className="my-custom-class"
              />
            </div>

            <div className="col-12 md:col-6 lg:col-6">
              <SelectField
                name="city"
                showClear
                label="City"
                value={formik.values.city}
                onChange={(e) => formik.setFieldValue('city', e.value)}
                options={cities.map(city => ({ label: city, value: city }))}
                error={formik.touched.city && formik.errors.city}
                required={true}
                className="w-full"
                disabled={cities.length === 0}
              />
            </div>

            <div className="col-12 md:col-6 lg:col-6">
              <InputField
                name="postcode"
                label="Postcode"
                // required={true}
                value={formik.values.postcode}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              // error={formik?.touched.postcode && formik.errors.postcode}
              />
            </div>

            <div className="col-12 md:col-6 lg:col-6">
              <InputField
                name="landmark"
                label="Landmark"

                value={formik.values.landmark}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik?.touched.landmark && formik.errors.landmark}
              />
            </div>

            <div className="col-12 md:col-6 lg:col-6">
              <InputField
                name="address1"
                label="Address Line 1"
                // required={true}
                value={formik.values.address1}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              // error={formik?.touched.address1 && formik.errors.address1}
              />
            </div>

            <div className="col-12 md:col-6 lg:col-6">
              <InputField
                name="address2"
                label="Address Line 2"
                value={formik.values.address2}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik?.touched.address2 && formik.errors.address2}
              />
            </div>

            <div className="col-12">
              <div className="form-group mb-1">
                <label className="label-form mb-1">Profile Image</label>
              </div>

              <ul className="fileupload p-list p-list-custom list-none flex flex-wrap gap-2 p-0 m-0">
                {previewUrl1 && (
                  <li className="p-list-item">
                    <img
                      src={previewUrl1}
                      alt=""
                      width={80}
                      height={80}
                    />
                  </li>
                )}
                {avatar && (avatar?.length > 0 && avatar?.length < 4) &&
                  <>
                    {avatar.map((item: any) => {
                      return (
                        <>
                          <li className="p-list-item">
                            <img src={item?.path} alt="Avatar Preview" width={70} height={70} />
                          </li>
                        </>
                      )
                    })}
                  </>}
                <li className="p-list-item">
                  <div className="avatar-upload">
                    <label htmlFor="imageUpload">
                      <i className="pi pi-cloud-upload" style={{ fontSize: '20px' }}></i>
                    </label>
                    <input
                      type="file"
                      id="imageUpload"
                      accept=".png, .jpg, .jpeg"
                      onChange={(e) => {
                        handleImageChange(e);
                      }}
                      style={{ visibility: 'hidden' }}
                    />
                    <div className="avatar-preview">
                      <div className="image-preview">
                        {previewUrl && (
                          <img src={previewUrl} alt="Avatar Preview" width={200} height={200} />
                        )}
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <div className="col-12 text-center">
              <Button
                label={id ? "Edit Customer" : "Add Customer"}
                type="submit"
                className="primary"
                loading={loading}
                disabled={loading}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
export default AddEditCustomer